import config from 'config'
import { selectAccount } from 'selectors/app'
import { createBasicSelector } from 'util/redux'

export const selectCanAccessDesignSystemDemo = createBasicSelector(
  selectAccount,
  account => {
    const isEnvWhitelisted =
      config.isDevelopment ||
      config.isDocker ||
      config.isStaging ||
      config.isAlpha

    return (
      isEnvWhitelisted || (!isEnvWhitelisted && account.subdomain === 'groove')
    )
  }
)
